import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import { RequestStatus } from '@beef/smart-kit';
import { IMAGE_DATA, DETALIZATION_MODAL_COMMON } from 'constants/detalization';

// Styles
import styles from '../ContentSection/styles.pcss';

const cx = classNames.bind(styles);

export const SuccessSection = ({ onClick }) => (
  <RequestStatus
    img={{ ...IMAGE_DATA, className: cx('success-icon') }}
    title={DETALIZATION_MODAL_COMMON.REPORT_SUCCESS}
    button={{
      text: 'Ok',
      size: 'm',
      variant: 'main',
    }}
    onConfirm={onClick}
  />
);

SuccessSection.propTypes = {
  onClick: PropTypes.func,
};
